export default __webpack_public_path__ + "static/media/info.e6ed2e56.png";